import { Layout, Text } from '@loadsmart/miranda-react'

import { numberFormatter } from '../../utils/number'
import { type ShippingItemsMeasures } from '../domain/ShippingItem'
import { formatVolume, formatLinearFeet } from '../presenters/DimensionsPresenter'
import { formatShippingItemsTitle } from '../presenters/ShippingItemsSummaryPresenter'
import { formatWeight } from '../presenters/WeightPresenter'
import { SummaryLabel } from './SummaryLabel'

export function ShippingItemsSummary({
  measures,
  showContent,
  count,
}: {
  measures: ShippingItemsMeasures
  showContent: boolean
  count?: number
}) {
  return (
    <Layout.Box
      borderColor="color-divider"
      borderWidth="border-thin"
      backgroundColor="color-background-secondary"
      padding="spacing-6"
    >
      <Layout.Stack gap="spacing-2">
        <Text variant="heading-sm-bold" color="color-text-secondary">
          Shipping items
        </Text>
        {showContent ? (
          <Layout.Group gap="spacing-4" align="center">
            <Text variant="body-md" color="color-text-primary">
              {formatShippingItemsTitle(count)}
            </Text>
            <SummaryLabel
              inline
              label="Weight"
              data-testid="shipping-item-summary-weight"
              value={`${formatWeight(measures.totalWeight)} lbs`}
            />
            <SummaryLabel
              inline
              label="Cube"
              data-testid="shipping-item-summary-cube"
              value={formatVolume(measures.volume)}
            />
            <SummaryLabel
              inline
              label="Density"
              data-testid="shipping-item-summary-density"
              value={`${numberFormatter(measures.density, 2)} PCF`}
            />
            <SummaryLabel
              inline
              label="Linear Feet"
              data-testid="shipping-item-summary-linear-feet"
              value={formatLinearFeet(measures.linearFeet)}
            />
          </Layout.Group>
        ) : (
          <Text variant="body-md" color="color-text-tertiary">
            No items added
          </Text>
        )}
      </Layout.Stack>
    </Layout.Box>
  )
}
